import Button from "@material-ui/core/Button";
import React from "react";
import { useResourceContext } from "react-admin";
import styled from "styled-components";

interface ListShowButtonProps {
  record: any;
}

export const StyledButton = styled(Button)({
  margin: "5px",
  padding: "0px 5px",
  fontWeight: "bold",
});

const ListShowButton: React.FC<ListShowButtonProps> = ({ record }) => {
  const resource = useResourceContext();

  return (
    <StyledButton variant="outlined" href={`/#/${resource}/${record.id}/show`}>
      VIEW
    </StyledButton>
  );
};

export default ListShowButton;
